import { LuPlus } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { useDockState } from '@/views/dock/dock-state';
import { useRequiredParams } from 'utils';
import { HouseholdHeaderActionsPortal } from 'views/household/HouseholdIndividualPage';
import { useListOpportunitiesByHousehold } from 'views/opportunities/opportunity-queries';
import OpportunityOverlays from 'views/opportunities/OpportunityOverlays';
import { OpportunityListView } from 'views/opportunities/widgets/OpportunityListView';

export const HouseholdOpportunitiesTab = () => {
    const { globalAccountGUID: householdGUID } = useRequiredParams(['globalAccountGUID']);
    const { data: opportunities = [], isLoading } = useListOpportunitiesByHousehold(householdGUID);
    const { addCreateOpportunityDockItem } = useDockState();

    return (
        <div>
            <HouseholdHeaderActionsPortal>
                <div className="flex items-center gap-4">
                    <Button variant="outline2" size="sm" onClick={() => addCreateOpportunityDockItem(householdGUID)}>
                        <LuPlus className="h-4 w-4" />
                        <span>Opportunity</span>
                    </Button>
                </div>
            </HouseholdHeaderActionsPortal>

            <OpportunityListView opportunities={opportunities} isLoading={isLoading} />

            <OpportunityOverlays />
        </div>
    );
};
